import { render, staticRenderFns } from "./AltaCuenta.vue?vue&type=template&id=4bdc0212"
import script from "./AltaCuenta.vue?vue&type=script&lang=js"
export * from "./AltaCuenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports